export default __webpack_public_path__ + "static/media/hht1_ep17_minisitcom_03.5c15a33d.png";